import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EventService {
  public routeChanged = new BehaviorSubject({ url: '/' })
}
